import { Outlet } from 'react-router-dom';
import { useVersionInfo } from '../contexts/version-info';
import { useContext, useEffect } from 'react';
import { GameDocumentContext } from '../contexts/game-document';

/**
 * The layout for pre-game screens.
 */
export const PreGameLayout = () => {
  const { setLoadedGameDocumentVersion } = useVersionInfo();
  const [gameState] = useContext(GameDocumentContext);

  useEffect(() => {
    const gameDocument = gameState?.gameDocument;

    if (!gameState || !gameDocument) {
      return;
    }

    setLoadedGameDocumentVersion(gameDocument.version);

    // Cleanup/reset
    return () => {
      setLoadedGameDocumentVersion(null);
    };
  }, [setLoadedGameDocumentVersion, gameState?.gameDocument?.version]);

  return (
    <div className={'layout layout--pre-game'}>
      <div className={'layout__container'}>
        <Outlet />
      </div>
    </div>
  );
};

export default PreGameLayout;
